import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import Login from "./pages/Login";
import WorkArrangementsTool from "./pages/WorkArrangementsTool";
import Welcome from "./pages/Welcome";
import CalculatorSelection from "./pages/CalculatorSelection";
import Layout from "./pages/Layout";
import LoadingProvider from "./components/LoadingContext";
import LoadingBar from "./components/LoadingBar";
import PriorSleepWakeTool from "./pages/PriorSleepWakeTool";
import SelfReportTool from "./pages/SelfReportTool";

// 👇 NEW: import the SurveyProvider
import { SurveyProvider } from "./context/SurveyContext";

const App: React.FC = () => {
  const [totalRiskScore, setTotalRiskScore] = useState<number | null>(null);
  const isAuthenticated = useIsAuthenticated();

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        {isAuthenticated ? (
          <Route
            path="*"
            element={
              // 👇 Wrap all protected routes in SurveyProvider
              <SurveyProvider>
                <Routes>
                  <Route
                    path="/welcome"
                    element={
                      <Layout>
                        <Welcome />
                      </Layout>
                    }
                  />
                  <Route
                    path="/WorkArrangementsTool"
                    element={
                      <LoadingProvider>
                        <LoadingBar />
                        <Layout>
                          <WorkArrangementsTool />
                        </Layout>
                      </LoadingProvider>
                    }
                  />
                  <Route
                    path="/PriorSleepWakeTool"
                    element={
                      <LoadingProvider>
                        <LoadingBar />
                        <Layout>
                          <PriorSleepWakeTool/>
                        </Layout>
                      </LoadingProvider>
                    }
                  />
                  <Route
                    path="/SelfReportTool"
                    element={
                      <LoadingProvider>
                        <LoadingBar />
                        <Layout>
                          <SelfReportTool />
                        </Layout>
                      </LoadingProvider>
                    }
                  />
                  <Route
                    path="/calculator-selection"
                    element={
                      <Layout>
                        <CalculatorSelection />
                      </Layout>
                    }
                  />
                </Routes>
              </SurveyProvider>
            }
          />
        ) : (
          <Route path="*" element={<Navigate to="/" />} />
        )}
      </Routes>
    </Router>
  );
};

export default App;
